import { useState } from "react";
import { Icon } from "./Icon.js";
import { useToast } from "./Toast.js";

const COPIED_MS = 1600;

export function CopyButton({ value, label = "Copy" }: { value: string; label?: string }) {
  const [copied, setCopied] = useState(false);
  const toast = useToast();

  async function copy(): Promise<void> {
    try {
      await navigator.clipboard.writeText(value);
    } catch {
      toast.show("Copy did not work here. Select the text and copy it by hand.", "error");
      return;
    }
    setCopied(true);
    setTimeout(() => { setCopied(false); }, COPIED_MS);
  }

  return (
    <button type="button" className={`copy-button${copied ? " is-copied" : ""}`} onClick={() => void copy()} aria-label={`${label}: ${value}`}>
      <Icon name={copied ? "check" : "copy"} size={14} />
      <span>{copied ? "Copied" : label}</span>
    </button>
  );
}
